import { parseChatMessage } from '../../../utils/chat';
import { Fetcher } from '../../Fetcher';

import type { ILiveSupportMessagesResponse, LiveSupportMessagesType } from './types';

export interface FetchLiveSupportMessagesParams {
  url: string;
  offset: number;
  recordsPerPage: number;
  tableId: string;
  tagMessage: string;
  timestamp: number;
  userId: string;
  action: string;
}

export const fetchLiveSupportMessages = ({
  url,
  offset,
  recordsPerPage,
  tableId,
  tagMessage,
  timestamp,
  userId,
  action,
}: FetchLiveSupportMessagesParams): Promise<LiveSupportMessagesType> => {
  return Fetcher.fetch<ILiveSupportMessagesResponse>(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      offset,
      recordsPerPage,
      tableId,
      tagMessage,
      timestamp,
      userId,
      action,
    },
  }).then((response) => response.list.map((message) => parseChatMessage(message)));
};
